import axios, { AxiosError } from 'axios'
import { stringify } from 'querystring'
import React, { useEffect, useState } from 'react'
import { Button, Form, FormGroup, Modal } from 'react-bootstrap'
import { Prev } from 'react-bootstrap/lib/Pagination'
import { validateCompanyName, validateEmail, validateName, validatePhoneNumber } from '../../../utility'
import { useTranslation } from 'react-i18next';
import { nanoid } from 'nanoid';
import { ContactRequest } from '../../../Types'
type Props = {
  whom: string
  show: boolean,
  onHide: any, // the actual type of onHid is React.Dispatch<React.SetStateAction<boolean>>
  reasons?: string[],
  products?: string[]
}

export default function SalesModal(props: Props) {
  const { t, i18n } = useTranslation();
  const [err, setErr] = useState<Map<string, string>>(new Map<string, string>())
  const [fields, setFields] = useState<ContactRequest>({ name: "", email: "", phoneNumber: "", companyName: "", contactReason: "", product: "", message: "" })
  const setField = (field: string, value: string) => {
    setFields({ ...fields, [field]: value })
  }
  let isValid = () => {
    let [result, msg] = validateName(fields.name)
    if (!result) {
      setErr(new Map<string, string>([["name", msg]]))
      return false
    }

    [result, msg] = validatePhoneNumber(fields.phoneNumber)
    if (!result) {
      setErr(new Map<string, string>([["phoneNumber", msg]]))
      return false
    }

    [result, msg] = validateEmail(fields.email)
    if (!result) {
      setErr(new Map<string, string>([["email", msg]]))
      return false
    }

    [result, msg] = validateCompanyName(fields.companyName)
    if (!result) {
      setErr(new Map<string, string>([["companyName", msg]]))
      return false
    }

    setErr(new Map<string, string>())
    return true
  }

  const validatiaon = (field: string, val: string) => {
    let [result, msg] = validator.get(field)!(val)
    if (!result) {
      err.set(field, msg)
    } else {
      err.clear()
    }
  }

  let validator = new Map<string, Function>([
    ["name", validateName],
    ["companyName", validateCompanyName],
    ["email", validateEmail],
    ["phoneNumber", validatePhoneNumber],
  ])


  const sendRequest = async () => {
    if (!isValid()) return

    axios.post("/api/contact/request", {
      ...fields,
      toWhom: props.whom
    })
    .then(()=>{
      alert("Message sent!");
    })
    .catch((err:AxiosError)=>{
      console.log(err)
      alert(err.response?.statusText)
    })
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('contact.contact')} {props.whom}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>{t('contact.name')}</Form.Label>
            <Form.Control
              type="text"
              placeholder="John Doe"
              autoFocus
              value={fields.name}
              onChange={(e) => {setField("name", e.target.value); validatiaon("name", e.target.value)}}
              isInvalid={err.has("name")}
            />
            <Form.Control.Feedback type="invalid">
              {err.get("name")}
            </Form.Control.Feedback>
          </Form.Group>

          <FormGroup>
            <Form.Label>{t('contact.phone number')}</Form.Label>
            <Form.Control
              type="text"
              placeholder="(123) 456-7890"
              value={fields.phoneNumber}
              onChange={(e) => {setField("phoneNumber", e.target.value); validatiaon("phoneNumber", e.target.value)}}
              isInvalid={err.has("phoneNumber")}
            />
            <Form.Control.Feedback type="invalid">
              {err.get("phoneNumber")}
            </Form.Control.Feedback>
          </FormGroup>

          <FormGroup>
            <Form.Label>{t('contact.email address')}</Form.Label>
            <Form.Control
              type="email"
              placeholder="Johndoe@google.com"
              value={fields.email}
              onChange={(e) => {setField("email", e.target.value);validatiaon("email", e.target.value)}}
              isInvalid={err.has("email")}
            />
            <Form.Control.Feedback type="invalid">
              {err.get("email")}
            </Form.Control.Feedback>
          </FormGroup>

          <FormGroup>
            <Form.Label>{t('contact.company')}</Form.Label>
            <Form.Control
              type="text"
              placeholder="Innovative Thinker"
              value={fields.companyName}
              onChange={(e) => {setField("companyName", e.target.value);validatiaon("companyName", e.target.value)}}
              isInvalid={err.has("companyName")}
            />
            <Form.Control.Feedback type="invalid">
              {err.get("companyName")}
            </Form.Control.Feedback>
          </FormGroup>

          {
            props.reasons && props.reasons.length > 0 &&
            <FormGroup>
              <Form.Label>{t('contact.contact reason')}</Form.Label>
              <Form.Select onChange={(e) => setField("contactReason", e.currentTarget.value)} isInvalid={err.has("contactReason")}>
                <option>{t('contact.open this select menu')}</option>
                {
                  props.reasons.map((e, i) => (
                    <option key={i} value={e}>{e}</option>
                  ))
                }
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {err.get("contactReason")}
              </Form.Control.Feedback>
            </FormGroup>
          }

          {
            props.products && props.products.length > 0 &&
            <FormGroup>
              <Form.Label>{t('contact.product')}</Form.Label>
              <Form.Select onChange={(e) => setField("product", e.currentTarget.value)} isInvalid={err.has("product")}>
                <option>{t('contact.open this select menu')}</option>
                {
                  props.products.map((e, i) => (
                    <option key={i} value={e}>{e}</option>
                  ))
                }
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {err.get("product")}
              </Form.Control.Feedback>
            </FormGroup>
          }


          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>{t('contact.message')}</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={fields.message}
              onChange={(e) => setField("message", e.target.value)} />
          </Form.Group>

        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => props.onHide()}>
          {t('close')}
        </Button>
        <Button variant="primary" onClick={sendRequest} disabled={err.size > 0}>
          {t('submit')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}